import React from 'react';
import { Box, Typography } from '@mui/material';

import { FormInput } from '@src/components/form-input';

import { useRedeemTransactionsContext } from '../provider';

const boxStyle = {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 1,
    marginTop: 2,
};

const BankDetails = ({ control }: any) => {
    const { state } = useRedeemTransactionsContext();
    const { selected } = state || {};

    if (selected?.redeemTypeID !== 1) return null;

    return (
        <>
            <Typography sx={{ m: 0, p: 2, fontSize: 14, fontWeight: "600" }}>
                Bank Details
            </Typography>
            <Box sx={boxStyle}>
                <FormInput
                    name="bank_FirstName"
                    control={control}
                    label="First Name"
                    disabled
                />
                <FormInput
                    name="bank_LastName"
                    control={control}
                    label="Last Name"
                    disabled
                />
            </Box>
            <Box sx={boxStyle}>
                <FormInput
                    name="bank_Name"
                    control={control}
                    label="Bank Name"
                    disabled
                />
                <FormInput
                    name="bank_AccountNumber"
                    control={control}
                    label="Account Number"
                    disabled
                />
            </Box>
            <Box sx={boxStyle}>
                <FormInput
                    name="bank_SwiftCode"
                    control={control}
                    label="Swift Code"
                    disabled
                />
                <FormInput
                    name="bank_IBAN_IBC_Code"
                    control={control}
                    label="IBAN or BIC"
                    disabled
                />
            </Box>
        </>
    );
}

export default BankDetails;